export default {
  map: 'Map',
  moreDetails: 'More details',
  maxPassenger: 'Max Passengers: {{number}}',
  btnBook: 'Book Ride', 
};